export const API_URLS = {
  base: process.env.NODE_ENV === "production"
    ? "https://poe-cluster-checker-production.up.railway.app"
    : "",
};


export const JEWEL_CONFIG = {
  large: {
    label: "Large Cluster Jewel",
    size: 8,
    ilvl: 0,
    count: 3,
    rules: [{ prefix: 2, suffix: 1 }],
  },
  medium: {
    label: "Medium Cluster Jewel",
    size: 5,
    ilvl: 0,
    count: 2,
    rules: [{ prefix: 2, suffix: 0 }],
  },
};

export const JEWEL_TYPES = {
  axe_attacks_deal_increased_damage: {
    label:
      "Added Small Passive Skills grant: Axe Attacks deal 12% increased Damage with Hits and Ailments\nSword Attacks deal 12% increased Damage with Hits and Ailments",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "1",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_4154008618",
        label: "Aggressive Defence",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3967765261",
        label: "Bloodscent",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3359207393",
        label: "Calamitous",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3944525413",
        label: "Feed the Fury",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3711553948",
        label: "Devastator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3599340381",
        label: "Fuel the Fight",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1911162866",
        label: "Drive the Destruction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_567971948",
        label: "Vicious Skewering",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1488030420",
        label: "Run Through",
        affix: "prefix",
      },
      {
        id: "explicit.stat_540300548",
        label: "Smite the Weak",
        affix: "suffix",
      },
      {
        id: "explicit.stat_69078820",
        label: "Wound Aggravation",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1152182658",
        label: "Martial Prowess",
        affix: "suffix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
    ],
  },
  staff_attacks_deal_increased_damage: {
    label:
      "Added Small Passive Skills grant: Staff Attacks deal 12% increased Damage with Hits and Ailments\nMace or Sceptre Attacks deal 12% increased Damage with Hits and Ailments",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "2",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_4154008618",
        label: "Aggressive Defence",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3359207393",
        label: "Calamitous",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3711553948",
        label: "Devastator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3944525413",
        label: "Feed the Fury",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1911162866",
        label: "Drive the Destruction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_394918362",
        label: "Expansive Might",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3599340381",
        label: "Fuel the Fight",
        affix: "prefix",
      },
      {
        id: "explicit.stat_567971948",
        label: "Vicious Skewering",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2250169390",
        label: "Overlord",
        affix: "prefix",
      },
      {
        id: "explicit.stat_540300548",
        label: "Smite the Weak",
        affix: "suffix",
      },
      {
        id: "explicit.stat_2244243943",
        label: "Weight Advantage",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1152182658",
        label: "Martial Prowess",
        affix: "suffix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
    ],
  },
  claw_attacks_deal_increased_damage: {
    label:
      "Added Small Passive Skills grant: Claw Attacks deal 12% increased Damage with Hits and Ailments\nDagger Attacks deal 12% increased Damage with Hits and Ailments",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "3",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_4154008618",
        label: "Aggressive Defence",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3359207393",
        label: "Calamitous",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3711553948",
        label: "Devastator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_183591019",
        label: "Disease Vector",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2484082827",
        label: "Fan of Blades",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3944525413",
        label: "Feed the Fury",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1911162866",
        label: "Drive the Destruction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3599340381",
        label: "Fuel the Fight",
        affix: "prefix",
      },
      {
        id: "explicit.stat_567971948",
        label: "Vicious Skewering",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1938661964",
        label: "Wind-up",
        affix: "prefix",
      },
      {
        id: "explicit.stat_540300548",
        label: "Smite the Weak",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1152182658",
        label: "Martial Prowess",
        affix: "suffix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
    ],
  },
  increased_damage_with_bows: {
    label:
      "Added Small Passive Skills grant: 12% increased Damage with Bows\n12% increased Damage Over Time with Bow Skills",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "4",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_3212859169",
        label: "Arcing Shot",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2205982416",
        label: "Broadside",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3359207393",
        label: "Calamitous",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3711553948",
        label: "Devastator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2631806437",
        label: "Tempered Arrowheads",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3944525413",
        label: "Feed the Fury",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1911162866",
        label: "Drive the Destruction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3599340381",
        label: "Fuel the Fight",
        affix: "prefix",
      },
      {
        id: "explicit.stat_567971948",
        label: "Vicious Skewering",
        affix: "prefix",
      },
      {
        id: "explicit.stat_540300548",
        label: "Smite the Weak",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1152182658",
        label: "Martial Prowess",
        affix: "suffix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
    ],
  },
  wand_attacks_deal_increased_damage: {
    label:
      "Added Small Passive Skills grant: Wand Attacks deal 12% increased Damage with Hits and Ailments",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "5",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_3359207393",
        label: "Calamitous",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3711553948",
        label: "Devastator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2017927451",
        label: "Explosive Force",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3944525413",
        label: "Feed the Fury",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1911162866",
        label: "Drive the Destruction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3599340381",
        label: "Fuel the Fight",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4281625943",
        label: "Opportunistic Fusilade",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1122051203",
        label: "Storm's Hand",
        affix: "prefix",
      },
      {
        id: "explicit.stat_567971948",
        label: "Vicious Skewering",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1152182658",
        label: "Martial Prowess",
        affix: "suffix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
    ],
  },
  increased_damage_with_two_handed_weapons: {
    label:
      "Added Small Passive Skills grant: 12% increased Damage with Two Handed Weapons",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "6",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_3359207393",
        label: "Calamitous",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3711553948",
        label: "Devastator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1499057234",
        label: "Battlefield Dominator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2068574831",
        label: "Brutal Infamy",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3134222965",
        label: "Fearsome Warrior",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3944525413",
        label: "Feed the Fury",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3599340381",
        label: "Fuel the Fight",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1903496649",
        label: "Graceful Execution",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1015189426",
        label: "Martial Mastery",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1911162866",
        label: "Drive the Destruction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3410752193",
        label: "Surefooted Striker",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2930275641",
        label: "Titanic Swings",
        affix: "prefix",
      },
      {
        id: "explicit.stat_567971948",
        label: "Vicious Skewering",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1152182658",
        label: "Martial Prowess",
        affix: "suffix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
    ],
  },
  increased_attack_damage_while_dual_wielding: {
    label:
      "Added Small Passive Skills grant: 12% increased Attack Damage while Dual Wielding",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "7",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_3359207393",
        label: "Calamitous",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3122505794",
        label: "Combat Rhythm",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1013470938",
        label: "Deadly Repartee",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3711553948",
        label: "Devastator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1911162866",
        label: "Drive the Destruction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3944525413",
        label: "Feed the Fury",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3599340381",
        label: "Fuel the Fight",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2665170385",
        label: "Hit and Run",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3904970959",
        label: "Insatiable Killer",
        affix: "prefix",
      },
      {
        id: "explicit.stat_684155617",
        label: "Mage Bane",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2978494217",
        label: "Martial Momentum",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2169345147",
        label: "Quick and Deadly",
        affix: "prefix",
      },
      {
        id: "explicit.stat_567971948",
        label: "Vicious Skewering",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1152182658",
        label: "Martial Prowess",
        affix: "suffix",
      },
      {
        id: "explicit.stat_540300548",
        label: "Smite the Weak",
        affix: "suffix",
      },
    ],
  },
  increased_attack_damage_while_holding_shield: {
    label:
      "Added Small Passive Skills grant: 12% increased Attack Damage while holding a Shield",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "8",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_3359207393",
        label: "Calamitous",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1625939562",
        label: "Advance Guard",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1591995797",
        label: "Gladiator's Fortitude",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3711553948",
        label: "Devastator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1911162866",
        label: "Drive the Destruction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3944525413",
        label: "Feed the Fury",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3599340381",
        label: "Fuel the Fight",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2335364359",
        label: "Precise Retaliation",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1705633890",
        label: "Prodigious Defence",
        affix: "prefix",
      },
      {
        id: "explicit.stat_254194892",
        label: "Riot Queller",
        affix: "prefix",
      },
      {
        id: "explicit.stat_282062371",
        label: "Strike Leader",
        affix: "prefix",
      },
      {
        id: "explicit.stat_664010431",
        label: "Veteran Defender",
        affix: "prefix",
      },
      {
        id: "explicit.stat_567971948",
        label: "Vicious Skewering",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1152182658",
        label: "Martial Prowess",
        affix: "suffix",
      },
      {
        id: "explicit.stat_540300548",
        label: "Smite the Weak",
        affix: "suffix",
      },
    ],
  },
  increased_attack_damage: {
    label: "Added Small Passive Skills grant: 10% increased Attack Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "9",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_3359207393",
        label: "Calamitous",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3711553948",
        label: "Devastator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1911162866",
        label: "Drive the Destruction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3944525413",
        label: "Feed the Fury",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3599340381",
        label: "Fuel the Fight",
        affix: "prefix",
      },
      {
        id: "explicit.stat_567971948",
        label: "Vicious Skewering",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3640252904",
        label: "Heavy Hitter",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1152182658",
        label: "Martial Prowess",
        affix: "suffix",
      },
      {
        id: "explicit.stat_540300548",
        label: "Smite the Weak",
        affix: "suffix",
      },
    ],
  },
  increased_spell_damage: {
    label: "Added Small Passive Skills grant: 10% increased Spell Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "10",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_77045106",
        label: "Ancestral Inspiration",
        affix: "prefix",
      },
      {
        id: "explicit.stat_393565679",
        label: "Arcane Adept",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3901992019",
        label: "Arcane Heroism",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2008682345",
        label: "Burden Projection",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4105031548",
        label: "Conjured Wall",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2118664144",
        label: "Mage Hunter",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3435403756",
        label: "Practiced Caster",
        affix: "prefix",
      },
      {
        id: "explicit.stat_876846990",
        label: "Seal Mender",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1096136223",
        label: "Essence Rush",
        affix: "suffix",
      },
      {
        id: "explicit.stat_715786975",
        label: "Sap Psyche",
        affix: "suffix",
      },
      {
        id: "explicit.stat_177215332",
        label: "Thaumophage",
        affix: "suffix",
      },
    ],
  },
  increased_elemental_damage: {
    label: "Added Small Passive Skills grant: 10% increased Elemental Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "11",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_1777139212",
        label: "Corrosive Elements",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3872380586",
        label: "Inspired Oppression",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2342448236",
        label: "Prismatic Heart",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3638731729",
        label: "Sadist",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3206911230",
        label: "Disorienting Display",
        affix: "suffix",
      },
      {
        id: "explicit.stat_228455793",
        label: "Doryani's Lesson",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1678643716",
        label: "Widespread Destruction",
        affix: "suffix",
      },
    ],
  },
  increased_physical_damage: {
    label: "Added Small Passive Skills grant: 12% increased Physical Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "12",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_4188581520",
        label: "Battle-Hardened",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3258653591",
        label: "Iron Breaker",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3585232432",
        label: "Master the Fundamentals",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1904581068",
        label: "Force Multiplier",
        affix: "suffix",
      },
      {
        id: "explicit.stat_3415827027",
        label: "Furious Assault",
        affix: "suffix",
      },
      {
        id: "explicit.stat_2194205899",
        label: "Grim Oath",
        affix: "suffix",
      },
    ],
  },
  increased_fire_damage: {
    label: "Added Small Passive Skills grant: 12% increased Fire Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "13",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_4199056048",
        label: "Burning Bright",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1777139212",
        label: "Corrosive Elements",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1153801980",
        label: "Cremator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1462135249",
        label: "Master of Fire",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2342448236",
        label: "Prismatic Heart",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3638731729",
        label: "Sadist",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2322980282",
        label: "Smoking Remains",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3206911230",
        label: "Disorienting Display",
        affix: "suffix",
      },
      {
        id: "explicit.stat_228455793",
        label: "Doryani's Lesson",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1678643716",
        label: "Widespread Destruction",
        affix: "suffix",
      },
    ],
  },
  increased_lightning_damage: {
    label: "Added Small Passive Skills grant: 12% increased Lightning Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "14",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_1777139212",
        label: "Corrosive Elements",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3872380586",
        label: "Inspired Oppression",
        affix: "prefix",
      },
      { id: "explicit.stat_3777170562", label: "Overshock", affix: "prefix" },
      { id: "explicit.stat_4272503233", label: "Paralysis", affix: "prefix" },
      {
        id: "explicit.stat_2342448236",
        label: "Prismatic Heart",
        affix: "prefix",
      },
      { id: "explicit.stat_3638731729", label: "Sadist", affix: "prefix" },
      {
        id: "explicit.stat_2589589781",
        label: "Scintillating Idea",
        affix: "prefix",
      },
      { id: "explicit.stat_1595367309", label: "Snowstorm", affix: "prefix" },
      {
        id: "explicit.stat_2087561637",
        label: "Storm Drinker",
        affix: "prefix",
      },
      { id: "explicit.stat_889728548", label: "Stormrider", affix: "prefix" },
      {
        id: "explicit.stat_1741700339",
        label: "Thunderstruck",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3206911230",
        label: "Disorienting Display",
        affix: "suffix",
      },
      {
        id: "explicit.stat_228455793",
        label: "Doryani's Lesson",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1678643716",
        label: "Widespread Destruction",
        affix: "suffix",
      },
    ],
  },
  increased_cold_damage: {
    label: "Added Small Passive Skills grant: 12% increased Cold Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "15",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_1085167979",
        label: "Blanketed Snow",
        affix: "prefix",
      },
      {
        id: "explicit.stat_693808153",
        label: "Blast-Freeze",
        affix: "prefix",
      },
      {
        id: "explicit.stat_744783843",
        label: "Cold to the Core",
        affix: "prefix",
      },
      {
        id: "explicit.stat_836566759",
        label: "Cold-Blooded Killer",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1777139212",
        label: "Corrosive Elements",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1703766309",
        label: "Deep Chill",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3872380586",
        label: "Inspired Oppression",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2342448236",
        label: "Prismatic Heart",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3638731729",
        label: "Sadist",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1595367309",
        label: "Snowstorm",
        affix: "prefix",
      },
      {
        id: "explicit.stat_889728548",
        label: "Stormrider",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3206911230",
        label: "Disorienting Display",
        affix: "suffix",
      },
      {
        id: "explicit.stat_228455793",
        label: "Doryani's Lesson",
        affix: "suffix",
      },
      {
        id: "explicit.stat_1678643716",
        label: "Widespread Destruction",
        affix: "suffix",
      },
    ],
  },
  increased_chaos_damage: {
    label: "Added Small Passive Skills grant: 12% increased Chaos Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "16",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_1603621602",
        label: "Dark Ideation",
        affix: "prefix",
      },
      {
        id: "explicit.stat_770408103",
        label: "Overwhelming Malice",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2780712583",
        label: "Touch of Cruelty",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2788982914",
        label: "Unwaveringly Evil",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1616734644",
        label: "Wicked Pall",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2194205899",
        label: "Grim Oath",
        affix: "suffix",
      },
      {
        id: "explicit.stat_4186213466",
        label: "Unholy Grace",
        affix: "suffix",
      },
      {
        id: "explicit.stat_729163974",
        label: "Unspeakable Gifts",
        affix: "suffix",
      },
    ],
  },
  minions_deal_increased_damage: {
    label:
      "Added Small Passive Skills grant: Minions deal 10% increased Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "17",
    sizes: ["large"],
    notables: [
      {
        id: "explicit.stat_383245807",
        label: "Feasting Fiends",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1038897629",
        label: "Raze and Pillage",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3607300552",
        label: "Renewal",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2289610642",
        label: "Rotten Claws",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1290215329",
        label: "Skeletal Atrophy",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3317068522",
        label: "Call to the Slaughter",
        affix: "suffix",
      },
      {
        id: "explicit.stat_622362787",
        label: "Primordial Bond",
        affix: "suffix",
      },
      {
        id: "explicit.stat_882876854",
        label: "Vicious Bite",
        affix: "suffix",
      },
    ],
  },
  //  MEDIUMS
  burning_damage: {
    label: "Added Small Passive Skills grant: 12% increased Burning Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "18",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_1612414696",
        label: "Blowback",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3250272113",
        label: "Brewed for Potency",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2900833792",
        label: "Brush with Death",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4199056048",
        label: "Burning Bright",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2129392647",
        label: "Circling Oblivion",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2938895712",
        label: "Cooked Alive",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1153801980",
        label: "Cremator",
        affix: "prefix",
      },
      {
        id: "explicit.stat_131358113",
        label: "Exposure Therapy",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3818661553",
        label: "Eye of the Storm",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2918755450",
        label: "Fan the Flames",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2350430215",
        label: "Flow of Life",
        affix: "prefix",
      },
      {
        id: "explicit.stat_72129119",
        label: "Haemorrhage",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1462135249",
        label: "Master of Fire",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2322980282",
        label: "Smoking Remains",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3202667190",
        label: "Student of Decay",
        affix: "prefix",
      },
      {
        id: "explicit.stat_647201233",
        label: "Vile Reinvigoration",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2066820199",
        label: "Wasting Affliction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_241783558",
        label: "Wrapped in Flame",
        affix: "prefix",
      },
    ],
  },
  chaos_damage_over_time: {
    label:
      "Added Small Passive Skills grant: 12% increased Chaos Damage over Time",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "19",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_3250272113",
        label: "Brewed for Potency",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2900833792",
        label: "Brush with Death",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2129392647",
        label: "Circling Oblivion",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1603621602",
        label: "Dark Ideation",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3737604164",
        label: "Eldritch Inspiration",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2144634814",
        label: "Eternal Suffering",
        affix: "prefix",
      },
      {
        id: "explicit.stat_131358113",
        label: "Exposure Therapy",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2350430215",
        label: "Flow of Life",
        affix: "prefix",
      },
      {
        id: "explicit.stat_72129119",
        label: "Haemorrhage",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3989400244",
        label: "Low Tolerance",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4290522695",
        label: "Septic Spells",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3500334379",
        label: "Steady Torment",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3202667190",
        label: "Student of Decay",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2788982914",
        label: "Unwaveringly Evil",
        affix: "prefix",
      },
      {
        id: "explicit.stat_647201233",
        label: "Vile Reinvigoration",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2066820199",
        label: "Wasting Affliction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1616734644",
        label: "Wicked Pall",
        affix: "prefix",
      },
    ],
  },
  physical_damage_over_time: {
    label:
      "Added Small Passive Skills grant: 12% increased Physical Damage over Time",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "20",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_2284771334",
        label: "Blood Artist",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3250272113",
        label: "Brewed for Potency",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2900833792",
        label: "Brush with Death",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2129392647",
        label: "Circling Oblivion",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4018305528",
        label: "Compound Injury",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3351136461",
        label: "Disorienting Wounds",
        affix: "prefix",
      },
      {
        id: "explicit.stat_131358113",
        label: "Exposure Therapy",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2350430215",
        label: "Flow of Life",
        affix: "prefix",
      },
      {
        id: "explicit.stat_72129119",
        label: "Haemorrhage",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3057154383",
        label: "Phlebotomist",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4263287206",
        label: "Rend",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3500334379",
        label: "Steady Torment",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3202667190",
        label: "Student of Decay",
        affix: "prefix",
      },
      {
        id: "explicit.stat_647201233",
        label: "Vile Reinvigoration",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3957006524",
        label: "Vivid Hues",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2066820199",
        label: "Wasting Affliction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_69078820",
        label: "Wound Aggravation",
        affix: "prefix",
      },
    ],
  },
  cold_damage_over_time: {
    label:
      "Added Small Passive Skills grant: 12% increased Cold Damage over Time",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "21",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_693808153",
        label: "Blast-Freeze",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3250272113",
        label: "Brewed for Potency",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2900833792",
        label: "Brush with Death",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2834490860",
        label: "Chilling Presence",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2129392647",
        label: "Circling Oblivion",
        affix: "prefix",
      },
      {
        id: "explicit.stat_836566759",
        label: "Cold-Blooded Killer",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1703766309",
        label: "Deep Chill",
        affix: "prefix",
      },
      {
        id: "explicit.stat_131358113",
        label: "Exposure Therapy",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2350430215",
        label: "Flow of Life",
        affix: "prefix",
      },
      {
        id: "explicit.stat_72129119",
        label: "Haemorrhage",
        affix: "prefix",
      },
      {
        id: "explicit.stat_647201233",
        label: "Vile Reinvigoration",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2066820199",
        label: "Wasting Affliction",
        affix: "prefix",
      },
    ],
  },
  damage_over_time: {
    label: "Added Small Passive Skills grant: 10% increased Damage over Time",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "22",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_3250272113",
        label: "Brewed for Potency",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2900833792",
        label: "Brush with Death",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2129392647",
        label: "Circling Oblivion",
        affix: "prefix",
      },
      {
        id: "explicit.stat_131358113",
        label: "Exposure Therapy",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2350430215",
        label: "Flow of Life",
        affix: "prefix",
      },
      {
        id: "explicit.stat_72129119",
        label: "Haemorrhage",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3202667190",
        label: "Student of Decay",
        affix: "prefix",
      },
      {
        id: "explicit.stat_647201233",
        label: "Vile Reinvigoration",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2066820199",
        label: "Wasting Affliction",
        affix: "prefix",
      },
    ],
  },
  non_damaging_ailments: {
    label:
      "Added Small Passive Skills grant: 10% increased Effect of Non-Damaging Ailments",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "23",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_2428334013",
        label: "Astonishing Affliction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_693808153",
        label: "Blast-Freeze",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2834490860",
        label: "Chilling Presence",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1274505521",
        label: "Cold Conduction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1703766309",
        label: "Deep Chill",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3818661553",
        label: "Eye of the Storm",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3872380586",
        label: "Inspired Oppression",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3777170562",
        label: "Overshock",
        affix: "prefix",
      },
      {
        id: "explicit.stat_889728548",
        label: "Stormrider",
        affix: "prefix",
      },
    ],
  },
  herald_damage: {
    label:
      "Added Small Passive Skills grant: 10% increased Damage while affected by a Herald",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "26",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_3122491961",
        label: "Agent of Destruction",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3784610129",
        label: "Dark Messenger",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2032453153",
        label: "Empowered Envoy",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2150878631",
        label: "Endbringer",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3274270612",
        label: "Heraldry",
        affix: "prefix",
      },
      {
        id: "explicit.stat_426715778",
        label: "Lasting Impression",
        affix: "prefix",
      },
      {
        id: "explicit.stat_507505131",
        label: "Purposeful Harbinger",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2644533453",
        label: "Self-Fulfilling Prophecy",
        affix: "prefix",
      },
    ],
  },
  minion_herald_damage: {
    label:
      "Added Small Passive Skills grant: Minions deal 10% increased Damage while you are affected by a Herald",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "27",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_2026112251",
        label: "Cult-Leader",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3177526694",
        label: "Disciples",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2150878631",
        label: "Endbringer",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3274270612",
        label: "Heraldry",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2262034536",
        label: "Invigorating Portents",
        affix: "prefix",
      },
      {
        id: "explicit.stat_426715778",
        label: "Lasting Impression",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1507409483",
        label: "Pure Agony",
        affix: "prefix",
      },
      {
        id: "explicit.stat_507505131",
        label: "Purposeful Harbinger",
        affix: "prefix",
      },
    ],
  },
  exerted_attacks: {
    label:
      "Added Small Passive Skills grant: Exerted Attacks deal 20% increased Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "28",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_1821748178",
        label: "Cry Wolf",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1080363357",
        label: "Haunting Shout",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3697635701",
        label: "Holy Word",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2195406641",
        label: "Lead By Example",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1048879642",
        label: "Mob Mentality",
        affix: "prefix",
      },
      {
        id: "explicit.stat_814369372",
        label: "Provocateur",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4288473380",
        label: "Rattling Bellow",
        affix: "prefix",
      },
      {
        id: "explicit.stat_578355556",
        label: "Warning Call",
        affix: "prefix",
      },
    ],
  },
  critical_strike_chance: {
    label:
      "Added Small Passive Skills grant: 15% increased Critical Strike Chance",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "29",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_3084359503",
        label: "Basics of Pain",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3818661553",
        label: "Eye of the Storm",
        affix: "prefix",
      },
      {
        id: "explicit.stat_72129119",
        label: "Haemorrhage",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2886441936",
        label: "Magnifier",
        affix: "prefix",
      },
      {
        id: "explicit.stat_770408103",
        label: "Overwhelming Malice",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2335364359",
        label: "Precise Retaliation",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3391925584",
        label: "Pressure Points",
        affix: "prefix",
      },
      {
        id: "explicit.stat_814369372",
        label: "Provocateur",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1626818279",
        label: "Quick Getaway",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4222635921",
        label: "Savage Response",
        affix: "prefix",
      },
      {
        id: "explicit.stat_315697256",
        label: "Skullbreaker",
        affix: "prefix",
      },
    ],
  },
  minion_life: {
    label:
      "Added Small Passive Skills grant: Minions have 12% increased maximum Life",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "30",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_1424794574",
        label: "Blessed Rebirth",
        affix: "prefix",
      },
      {
        id: "explicit.stat_791125124",
        label: "Bodyguards",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3087667389",
        label: "Dread March",
        affix: "prefix",
      },
      {
        id: "explicit.stat_383245807",
        label: "Feasting Fiends",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3467711950",
        label: "Hulking Corpses",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2337273077",
        label: "Life from Death",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3607300552",
        label: "Renewal",
        affix: "prefix",
      },
    ],
  },
  area_damage: {
    label: "Added Small Passive Skills grant: 10% increased Area Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "31",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_4222265138",
        label: "Assert Dominance",
        affix: "prefix",
      },
      {
        id: "explicit.stat_394918362",
        label: "Expansive Might",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2886441936",
        label: "Magnifier",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1005475168",
        label: "Powerful Assault",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2930275641",
        label: "Titanic Swings",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3536778624",
        label: "Towering Threat",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1996576560",
        label: "Vast Power",
        affix: "prefix",
      },
    ],
  },
  projectile_damage: {
    label: "Added Small Passive Skills grant: 10% increased Projectile Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "32",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_4120556534",
        label: "Aerodynamics",
        affix: "prefix",
      },
      {
        id: "explicit.stat_392942015",
        label: "Eye to Eye",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3984980429",
        label: "Follow-Through",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2233272527",
        label: "Repeater",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2783012144",
        label: "Shrieking Bolts",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1397498432",
        label: "Streamlined",
        affix: "prefix",
      },
    ],
  },
  trap_and_mine_damage: {
    label:
      "Added Small Passive Skills grant: 12% increased Trap Damage / 12% increased Mine Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "33",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_2043503530",
        label: "Arcane Pyrotechnics",
        affix: "prefix",
      },
      {
        id: "explicit.stat_456502758",
        label: "Careful Handling",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2020075345",
        label: "Expendability",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2084371547",
        label: "Expert Sabotage",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1882129725",
        label: "Guerilla Tactics",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1101250813",
        label: "Set and Forget",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3051562738",
        label: "Surprise Sabotage",
        affix: "prefix",
      },
    ],
  },
  totem_damage: {
    label: "Added Small Passive Skills grant: 12% increased Totem Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "34",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_957679205",
        label: "Ancestral Echo",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2387747995",
        label: "Ancestral Guidance",
        affix: "prefix",
      },
      {
        id: "explicit.stat_77045106",
        label: "Ancestral Inspiration",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3998316",
        label: "Ancestral Might",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3746703776",
        label: "Ancestral Preservation",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3294884567",
        label: "Ancestral Reach",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3993957711",
        label: "Sleepless Sentries",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3319205340",
        label: "Snaring Spirits",
        affix: "prefix",
      },
    ],
  },
  brand_damage: {
    label: "Added Small Passive Skills grant: 12% increased Brand Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "35",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_3198006994",
        label: "Brand Loyalty",
        affix: "prefix",
      },
      {
        id: "explicit.stat_968069586",
        label: "Chip Away",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2350900742",
        label: "Grand Design",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3898572660",
        label: "Holy Conquest",
        affix: "prefix",
      },
      {
        id: "explicit.stat_691431951",
        label: "Remarkable",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2261237498",
        label: "Seeker Runes",
        affix: "prefix",
      },
    ],
  },
  channelling_damage: {
    label:
      "Added Small Passive Skills grant: Channelling Skills deal 12% increased Damage",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "36",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_2522970386",
        label: "Enduring Focus",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2341828832",
        label: "Hex Breaker",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2913581789",
        label: "Precise Focus",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1088949570",
        label: "Stoic Focus",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1570474940",
        label: "Unrestrained Focus",
        affix: "prefix",
      },
      {
        id: "explicit.stat_367638058",
        label: "Unwavering Focus",
        affix: "prefix",
      },
      {
        id: "explicit.stat_2134141047",
        label: "Vital Focus",
        affix: "prefix",
      },
    ],
  },
  flask_duration: {
    label:
      "Added Small Passive Skills grant: 6% increased Flask Effect Duration",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "37",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_3250272113",
        label: "Brewed for Potency",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3652138990",
        label: "Distilled Perfection",
        affix: "prefix",
      },
      {
        id: "explicit.stat_37078857",
        label: "Fasting",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1094635162",
        label: "Liquid Inspiration",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4291434923",
        label: "Mender's Wellspring",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1028754276",
        label: "Numbing Elixir",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1722821275",
        label: "Peak Vigour",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4235300427",
        label: "Special Reserve",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3372255769",
        label: "Spiked Concoction",
        affix: "prefix",
      },
    ],
  },
  flask_recovery: {
    label:
      "Added Small Passive Skills grant: 10% increased Life Recovery from Flasks / 10% increased Mana Recovery from Flasks",
    enchantStatId: "enchant.stat_3948993189",
    enchantOption: "38",
    sizes: ["medium"],
    notables: [
      {
        id: "explicit.stat_3250272113",
        label: "Brewed for Potency",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3652138990",
        label: "Distilled Perfection",
        affix: "prefix",
      },
      {
        id: "explicit.stat_37078857",
        label: "Fasting",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1094635162",
        label: "Liquid Inspiration",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4291434923",
        label: "Mender's Wellspring",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1028754276",
        label: "Numbing Elixir",
        affix: "prefix",
      },
      {
        id: "explicit.stat_1722821275",
        label: "Peak Vigour",
        affix: "prefix",
      },
      {
        id: "explicit.stat_4235300427",
        label: "Special Reserve",
        affix: "prefix",
      },
      {
        id: "explicit.stat_3372255769",
        label: "Spiked Concoction",
        affix: "prefix",
      },
    ],
  },
};
